import { createSelector } from '@reduxjs/toolkit'
import { servicesSlice } from '@/store/servicesSlice'
import { getBoughtServicesTotal } from '@/utils/timeSchedules'
import { cartSlice } from '..'

export const totalGlobalBoughtQuantitySelector = createSelector(
  [
    servicesSlice.selectors.data,
    cartSlice.selectors.selectedElementReservation,
  ],
  (services, selectedElementReservation): number => {
    if (!services?.hasLimit || selectedElementReservation === null) {
      return 0
    }

    const ticketIds = services.ticketServices.map(
      (service) => service.serviceId
    )

    return Object.entries(
      selectedElementReservation.boughtServices
    ).reduce<number>((total, entry) => {
      const [key, boughtService] = entry
      const serviceId = Number(key)

      if (ticketIds.includes(serviceId)) {
        total += getBoughtServicesTotal(boughtService)
      }

      return total
    }, 0)
  }
)
